<template>
    <div v-if="workflow.length > 0 && $parent.permissionAllowed('workflow_view')" class="workflow-container clearfix">
        <ul class="workflow-listing clearfix">
            <li v-for="steps in workflow" :class="steps.status" :style="{ width: stepWidth + '%' }" class="workflow-item">
                <div class="workflow-node"></div>
                <div class="workflow-label">
                    {{steps.name}}
                    <span class="workflow-description">{{steps.description}}</span>
                </div>
                <div class="all-completed"><i class="fa fa-check" aria-hidden="true"></i></div>
            </li>
        </ul>
        <transition name="vue-table-loader">
            <div class="vue-details-loader" v-if="this.loadingStatus"><span class="fa fa-cog fa-spin fa-1x"></span></div>
        </transition>
    </div>
</template>

<style scoped lang="scss">
    .workflow-container{
        height: 54px;
        position: relative;
        .workflow-listing{
            list-style-type: none;
            padding-left: 0px;
            margin-bottom: 20px;
        }
        .workflow-item{
            position: relative;
            height: 20px;
            display: block;
            float: left;
            text-align: center;
            .all-completed{
                display: none;
                position: absolute;
                top: -3px;
                right: 0px;
                width: 20px;
                height: 20px;
                background-color: #fff;
                border-radius: 50%;
                border: 2px solid #3CAB9F;
                color: #3CAB9F;
                .fa{
                    position: relative;
                    top: -1px;
                }
            }
            .workflow-node{
                margin: 0 auto;
                height: 10px;
                width: 10px;
                position: relative;
                background: #F0F3F6;
                border: 2px solid #C4C0C0;
                border-radius: 50%;
            }
            .workflow-label{
                overflow:hidden;
                position: relative;
                display: inline-block;
                margin-top: 13px;
                text-align: center;
                font-size: 9px;
                color: #9c9a9a;
                letter-spacing: 0;
                .workflow-description{
                    transition: opacity 0.3s;
                    text-align: left;
                    position: absolute;
                    z-index:10;
                    bottom: 12px;
                    right: -149px;
                    opacity:0;
                    width: 150px;
                    background-color: rgba(255,255,255,0.9);
                    color:#576670;
                    border-radius: 3px;
                    padding: 10px;
                    border: 1px solid #DEDEDE;
                    box-shadow: 0 1px 3px 0 rgba(0,0,0,0.08);
                }
                &:hover{
                    overflow: initial;
                     .workflow-description{
                        transition: opacity 0.3s;
                        opacity:1;
                     }
                }
            }
            &:before{
                content:"";
                position: relative;
                top: 6px;
                display: block;
                height: 2px;
                width: 100%;
                background: #C4C0C0;
            }
            &.completed{
                .workflow-label{
                    color :#3CAB9F;
                }
                .workflow-node{
                    background :#3CAB9F;
                    border-color:#3CAB9F;
                }
                &:before{
                    background: #3CAB9F;
                }
            }
            &.active{
                .workflow-label{
                    color: #25628F;
                }
                .workflow-node{
                    background: #fff;
                    border-color: #25628F;
                }
                &:before{
                    background: #3cab9f;
                    background: -moz-linear-gradient(left, #3cab9f 0%, #3cab9f 50%, #c4c0c0 50%, #c4c0c0 100%);
                    background: -webkit-linear-gradient(left, #3cab9f 0%,#3cab9f 50%,#c4c0c0 50%,#c4c0c0 100%);
                    background: linear-gradient(to right, #3cab9f 0%,#3cab9f 50%,#c4c0c0 50%,#c4c0c0 100%);
                }
            }
            &:last-of-type{
                &.active{
                    .workflow-label{
                        color :#3CAB9F;
                    }
                    .workflow-node{
                        background :#3CAB9F;
                        border-color:#3CAB9F;
                    }
                    .all-completed{
                        display: block;
                    }
                    &:before{
                        background: #3CAB9F;
                    }
                }
            }
        }

    }
    .vue-details-loader{
        top: -9px;
        background:rgba(249, 251, 255, 0.9);
        padding: 17px 10px;
        text-align: center;
    }
</style>

<script type="text/javascript">
    var base_url = window.location.protocol + "//" + window.location.host

    import Vue from 'vue';
    import VueEvents from 'vue-events'
    import axios from 'axios'
    import select2 from 'select2';

    Vue.use(VueEvents)

    export default {
        name: 'product-workflow',
        props: ['workflow', 'loadingStatus'],
        components:{
        },
        data() {
            return {
                stepWidth: null,
            }
        },
        mounted() {

        },
        created() {
            this.progressWidth();
        },
        watch: {

        },
        methods: {
            progressWidth: function () {
                this.stepWidth = Math.floor((100 / this.workflow.length) * 100) / 100;
            }
        }
    };
</script>